var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGusto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F45D48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7045 13.6485V5.19395H14.413V5.76142C13.6444 5.26578 12.7394 5 11.8271 5C9.16932 5 7 7.16932 7 9.84864C7 12.5208 9.16932 14.6973 11.8271 14.6973C12.7322 14.6973 13.6229 14.4459 14.3915 13.9574C14.3915 14.0292 14.3915 14.0939 14.3915 14.1442C14.3915 15.5521 13.2494 16.6942 11.8486 16.6942C11.3746 16.6942 10.9076 16.5577 10.5054 16.3063L9.37045 18.3032C10.1175 18.7558 10.9795 19 11.8558 19C14.5208 19 16.7188 16.8235 16.7188 14.1514C16.7045 14.0508 16.7116 13.7491 16.7045 13.6485ZM11.8199 12.4058C10.4192 12.4058 9.27706 11.2637 9.27706 9.85582C9.27706 8.44792 10.4192 7.3058 11.8199 7.3058C13.2206 7.3058 14.3627 8.44792 14.3627 9.85582C14.3627 11.2637 13.2206 12.4058 11.8199 12.4058Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGusto);
export default __webpack_public_path__ + "static/media/gusto.5e95d5a2bd6d4096d9563a467b51485c.svg";
export { ForwardRef as ReactComponent };